import $ from "jquery";
import { active } from "./const.js";

document.addEventListener("DOMContentLoaded", function () {
  function truncateText() {
    document.querySelectorAll(".js-expandableText").forEach(element => {
      const maxLength = element.getAttribute("data-truncate");

      if (!maxLength) return; // data-truncate がない場合は処理しない

      const maxLengthNum = parseInt(maxLength, 10);
      const fullText = element.getAttribute("data-fulltext") || element.textContent.trim();

      if (!element.hasAttribute("data-fulltext")) {
        element.setAttribute("data-fulltext", fullText); // 元のテキストを保存（最初の実行時のみ）
      }

      if (window.matchMedia("(max-width: 767px)").matches) {
        if (fullText.length > maxLengthNum) {
          const truncatedText = fullText.slice(0, maxLengthNum) + "… ";
          const readMoreSpan = document.createElement("span");
          readMoreSpan.textContent = " 続きを読む";

          element.innerHTML = truncatedText;
          element.appendChild(readMoreSpan);

          readMoreSpan.addEventListener("click", function () {
            element.textContent = fullText; // 元の全文を表示
          });
        }
      } else {
        // 画面幅が広い場合は全文表示
        element.textContent = fullText;
      }
    });
  }

  truncateText(); // 初回実行

  // 画面幅が変更されたときにも適用
  window.addEventListener("resize", truncateText);
});
